import React from 'react';
import { Row, Col } from 'antd';
import './index.css'
import DetailItem from '../../CSIComponents/DetailItem';
import Collapse, { Panel } from '../../ui/Collapse';
interface propsType {
    detailData: object | any
}
const GeneralCertificationsDetail = (props: propsType) => {
    const detailData = props?.detailData?.environmentalimpact?.general?.certifications || []

    return (
        <Collapse
            defaultActiveKey={detailData.map((_: object, i : number) => i)}
            multiCollapseButton
        >
            <>
                {
                    detailData.map((item: { name: any; }, i: number) => (
                        <Panel header={`Certification ${i + 1}`} key={i}>
                            <Row gutter={24}>
                                <Col span={6}>
                                    <DetailItem value={item.name} label="Name"></DetailItem>
                                </Col>
                            </Row>
                        </Panel>
                    ))
                }
            </>
        </Collapse>
    )
}

export default GeneralCertificationsDetail;

